import { MetaType } from "../types"
import {
  actionCreatorGuard,
  reducerGuard,
  processActionMeta,
  getArrayReducerGuard
} from "../reducers"

const kind = "block_empty"

// Just here for reference -- will never be persisted to db
export type BlockEmpty = {
  kind: typeof kind
  version: number
  type: "empty"
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<BlockEmpty, MetaType>("meta", kind),
  type: actionCreatorGuard<BlockEmpty, string>("type", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    BlockEmpty,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const blockEmptyAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const blockEmptyReducer = reducerGuard<BlockEmpty>(kind)
  .case(...reducerAction.meta)
  .build()
